import { createXPointScale, createYScale, defaultDataIdAssessor, IMargin } from '@opengov/data-viz';

import { IChartConfigurator, ILineChartCalculations } from './types';

import { sortCategories } from './categories';
import { assembleAllColors, makeCoordinateSystems, ticksLengthOfShowAsPercentOfTotal } from './chartCalculations';
import { dataValuesToRange, uniqueDataValues } from './values';

export const createLineChartCalculations = (
  config: IChartConfigurator,
  showAsPercentOfTotal: boolean,
  margin: IMargin,
  maxXTickWidth: number,
  customColors?: { [key: string]: string },
  additionalScaleData?: number[]
): ILineChartCalculations => {
  const { data, sortOrder, width } = config;
  const { coordinateSystem, dimensions, margin: newMargin } = makeCoordinateSystems(margin, width);

  const values = uniqueDataValues(data, additionalScaleData);
  const scaleValues = dataValuesToRange(values, showAsPercentOfTotal);
  const { sortedCategoriesForColorScale, sortedCategories } = sortCategories(data, sortOrder, showAsPercentOfTotal);
  const numberOfYTicks = ticksLengthOfShowAsPercentOfTotal(showAsPercentOfTotal);
  const y = createYScale(scaleValues, dimensions.height, numberOfYTicks);
  const x = createXPointScale(data.map(defaultDataIdAssessor), dimensions.width);
  const colorMap = assembleAllColors(sortedCategoriesForColorScale, customColors);

  return {
    categories: sortedCategories,
    coordinateSystem,
    colorMap: colorMap as any,
    data,
    dimensions,
    margin: newMargin,
    xScale: x,
    yScale: y,
    xTickLabelWidth: maxXTickWidth,
    yTickLabelWidth: 0,
    numberOfYTicks: numberOfYTicks,
    showAsPercentOfTotal: showAsPercentOfTotal
  };
};
